import { Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';
import { SlaFormField } from '~/app/landing/sla/shared/components/SlaFormField';
import { SlaModalFieldGrid } from '~/app/landing/sla/shared/components/SlaModalFieldGrid';
import { MAINTENANCE_TIMEZONE_OPTIONS } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/utils';
import type { MaintenanceSlaHeaderFieldsProps } from '~/app/landing/sla/oems/components/MaintenanceSlaContract/components/MaintenanceSlaHeaderFields/MaintenanceSlaHeaderFields';

export function MaintenanceSlaHeaderIdentityFields({
  draft,
  onChange,
}: MaintenanceSlaHeaderFieldsProps) {
  const { t } = useTranslation('sla');

  return (
    <SlaModalFieldGrid columns={2}>
      <SlaFormField label={t('oems.maintenance.fields.timezone')}>
        <Select
          style={{ width: '100%' }}
          value={draft.timezone}
          options={MAINTENANCE_TIMEZONE_OPTIONS}
          onChange={(timezone) => onChange({ timezone })}
        />
      </SlaFormField>
      <SlaFormField label={t('oems.maintenance.fields.holidayCalendarCode')}>
        <Input
          value={draft.holidayCalendarCode}
          onChange={(event) =>
            onChange({ holidayCalendarCode: event.target.value })
          }
        />
      </SlaFormField>
    </SlaModalFieldGrid>
  );
}
